<template>
  <b-card no-body>
    <b-card-header>
      <b-card-title>Số lượng lớp cố định theo từng Khóa</b-card-title>
      <b-dropdown
        dropright
        variant="link"
        toggle-class="p-0"
        no-caret
      >
        <template #button-content>
          <feather-icon
            class="text-body"
            icon="FilterIcon"
          />
        </template>
        <b-dropdown-item
          v-for="(item, index) in itemCourses"
          @click="selectItem(item)"
          :key="index">
          {{ item.name }}
        </b-dropdown-item>
      </b-dropdown>
    </b-card-header>
    <b-card-body>
      <bar-chart-component
        ref="barChart1"
        id="bar-chart-1"
        :height="400"
        :data="classByCoursesAndDepartment.data"
        :options="classByCoursesAndDepartment.options"
      />
    </b-card-body>
    <b-card class="text-center" > {{ this.subTitle }} </b-card>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BCardTitle, BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import BarChartComponent from "@/views/admin/category/charts/component/BarChartComponent.vue";
import { mapActions, mapGetters } from "vuex";
import { $themeColors } from "@themeConfig";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BDropdownItem, BDropdown,
    BCard,
    BCardHeader,
    BCardBody,
    BCardTitle,
    BarChartComponent
  },
  props: {
    filter: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      itemCourses: [],
      subTitle: null,
      classByCoursesAndDepartment: {
        data: {
          labels: [],
          datasets: [
            {
              data: [],
              backgroundColor: chartColors.successColorShade,
              borderColor: 'transparent',
            },
          ],
        },
        options: {
          elements: {
            rectangle: {
              borderWidth: 2,
              borderSkipped: 'bottom',
            },
          },
          responsive: true,
          maintainAspectRatio: false,
          responsiveAnimationDuration: 500,
          legend: {
            display: false,
          },
          tooltips: {
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 8,
            shadowColor: chartColors.tooltipShadow,
            backgroundColor: $themeColors.light,
            titleFontColor: $themeColors.dark,
            bodyFontColor: $themeColors.dark,
          },
          scales: {
            xAxes: [
              {
                display: true,
                gridLines: {
                  display: true,
                  color: chartColors.grid_line_color,
                  zeroLineColor: chartColors.grid_line_color,
                },
                scaleLabel: {
                  display: false,
                },
                ticks: {
                  fontColor: chartColors.labelColor,
                },
              },
            ],
            yAxes: [
              {
                display: true,
                gridLines: {
                  color: chartColors.grid_line_color,
                  zeroLineColor: chartColors.grid_line_color,
                },
                ticks: {
                  stepSize: 10,
                  min: 0,
                  fontColor: chartColors.labelColor,
                },
              },
            ],
          },
        },
      },
    }
  },
  computed: {
    ...mapGetters( {
      courses: 'chart/coursesByTrainingSystemAndYear',
      countClassByCoursesAndDepartment: 'chart/countClassByCoursesAndDepartment',
    }),
  },
  watch: {
    'filter.trainingSystemId': async function () {
      await this.getDataFromStore()
    },
    'filter.yearId': async function () {
      await this.getDataFromStore()
    },
    'filter.semesterId': async function () {
      await this.getDataFromStore()
    }
  },
  async created() {
    await this.getDataFromStore()
  },
  methods:{
    ...mapActions({
      getCoursesByTrainingSystemAndYear: 'chart/getCoursesByTrainingSystemAndYear',
      getCountClassByCoursesAndDepartment: 'chart/getCountClassByCoursesAndDepartment',
    }),
    async getDataFromStore(){
      this.isLoading = true
      try {
        await Promise.all([
          this.getCountClassByCoursesAndDepartment(this.filter),
          this.getCoursesByTrainingSystemAndYear(this.filter)
        ])
        if (this.courses.length > 0) {
          this.itemCourses = []
          this.courses.forEach((item, key) => {
            this.itemCourses.push(this.courses[key])
          })
          this.itemCourses = this.itemCourses.reverse()
        }
        if (this.countClassByCoursesAndDepartment.length > 0) {
          this.classByCoursesAndDepartment.data.labels = []
          this.classByCoursesAndDepartment.data.datasets[0].data = []
          this.countClassByCoursesAndDepartment.forEach((item, key) => {
            this.classByCoursesAndDepartment.data.labels.push(item.departmentName)
            this.classByCoursesAndDepartment.data.datasets[0].data.push(item.countClass)
          })
          this.$refs.barChart1.renderChart(this.classByCoursesAndDepartment.data, this.classByCoursesAndDepartment.options)
        }
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `[${e.code}] ${e.message}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.isLoading = false
      }
    },
    async selectItem(item) {
      if (item != null) {
        this.subTitle = item.name
      }
      this.filter.coursesId = item.id
      await this.getDataFromStore()
    }
  }
}

const chartColors = {
  primaryColorShade: '#836AF9',
  yellowColor: '#ffe800',
  successColorShade: '#28dac6',
  warningColorShade: '#ffe802',
  warningLightColor: '#FDAC34',
  infoColorShade: '#299AFF',
  greyColor: '#4F5D70',
  blueColor: '#2c9aff',
  blueLightColor: '#84D0FF',
  greyLightColor: '#EDF1F4',
  tooltipShadow: 'rgba(0, 0, 0, 0.25)',
  lineChartPrimary: '#666ee8',
  lineChartDanger: '#ff4961',
  labelColor: '#6e6b7b',
  grid_line_color: 'rgba(200, 200, 200, 0.2)',
}
</script>
